export default __webpack_public_path__ + "static/media/Adrish.da2b6722.png";